import { authorizedRequest, HTTP_METHODS } from "utils/request";
import Polling from "./Polling";

export default class Poller {
  constructor(
    tokenUrl,
    resultUrl,
    successAction,
    failedAction,
    startAction = () => {},
  ) {
    this.poller = new Polling();
    this.successAction = successAction;
    this.failedAction = failedAction;
    this.startAction = startAction;
    this.tokenUrlRaw = tokenUrl;
    this.resultUrlRaw = resultUrl;
  }

  get tokenUrl() {
    if (typeof this.tokenUrlRaw === "function") {
      return this.tokenUrlRaw();
    }
    return this.tokenUrlRaw;
  }

  get resultUrl() {
    if (typeof this.resultUrlRaw === "function") {
      return this.resultUrlRaw();
    }
    return this.resultUrlRaw;
  }

  handleData = (err, data) => {
    if (err) {
      this.failedAction(err);
    } else {
      this.successAction(data.additional_data.available_timewindows);
    }
  };

  async getData(body) {
    this.startAction();
    if (this.poller && this.poller.isPolling) {
      this.poller.stop();
      this.poller.removeCallback(this.handleData);
    }

    let token = null;
    try {
      const res = await authorizedRequest(this.tokenUrl, {
        method: HTTP_METHODS.POST,
        body,
      });

      token = res.additional_data.token;
    } catch (e) {
      this.failedAction(e);
      return;
    }

    this.poller = new Polling({ data: { token } }, this.resultUrl);
    this.poller.registerCallback(this.handleData);
    this.poller.start();
  }
}
